import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Button } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import * as userService from '../Services/userService';
import useAuthStore from '../../../stores/authStore';

const Notifications = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const user = useAuthStore((state) => state.user);
  const setUserDataSettings = useAuthStore((state) => state.setUserDataSettings);

  const [userSettings, setUserSettings] = useState({
    SendMailWhenNewApplication: false,
    SendMailWhenJobExpires: false,
  });

  useEffect(() => {
    if (!user || !user.settings) {
      return;
    }

    const getSettingValue = (name) => {
      const found = user.settings.find((s) => s.name === name);
      return found ? found.value === '1' : false;
    };

    setUserSettings({
      SendMailWhenNewApplication: getSettingValue('SendMailWhenNewApplication'),
      SendMailWhenJobExpires: getSettingValue('SendMailWhenJobExpires'),
    });
  }, [user, history]);

  const updateUserSettings = async (event) => {
    event.preventDefault();

    const settingsPayload = [
      { id: 0, name: 'SendMailWhenJobExpires', value: userSettings.SendMailWhenJobExpires ? 1 : 0 },
      { id: 0, name: 'SendMailWhenNewApplication', value: userSettings.SendMailWhenNewApplication ? 1 : 0 },
    ];

    try {
      const response = await userService.updateUserSettings(settingsPayload);
      // Update Zustand store with new user settings
      setUserDataSettings({ settings: response.data.settings });
    } catch (err) {
      // Optionally handle error
    }
  };

  const onCheckBoxChange = (event) => {
    const field = event.target.name;
    const val = event.currentTarget.checked;
    setUserSettings((prev) => ({ ...prev, [field]: val }));
  };

  if (!user) return null;

  return (
    <Card className="card-default">
      <div className="card-header bg-gray-lighter text-bold">{t('settings.SETTINGS')}</div>
      <div className="card-body">
        <form onSubmit={updateUserSettings}>
          <div className="checkbox c-checkbox px-4">
            <label>
              <input
                id="SendMailWhenNewApplication"
                type="checkbox"
                name="SendMailWhenNewApplication"
                onChange={onCheckBoxChange}
                checked={userSettings.SendMailWhenNewApplication}
              />
              <span className="fa fa-check"></span> {t('settings.EMAIL_WHEN_NEW_APPLICATION')}
            </label>
          </div>
          <div className="checkbox c-checkbox px-4">
            <label>
              <input
                id="SendMailWhenJobExpires"
                type="checkbox"
                name="SendMailWhenJobExpires"
                onChange={onCheckBoxChange}
                checked={userSettings.SendMailWhenJobExpires}
              />
              <span className="fa fa-check"></span> {t('settings.EMAIL_WHEN_JOB_EXPIRES')}
            </label>
          </div>
          {user.role === 'Admin' ? (
            <p className="text-warning">TODO: admin can not yet change settings for other users!</p>
          ) : null}
          <Button color="info" type="submit">
            {t('common.SAVE')}
          </Button>
        </form>
      </div>
    </Card>
  );
};

export default Notifications;
